import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { toast, ToastContainer } from 'react-toastify';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { ResponseError } from '../../../common/spdCore/autogenerated/spdApiClient';

export const JudgmentPreviewLink = (props: {
  judgmentId: string;
  engPdfTemplateType?: string | null;
}) => {
  const spd = useSpdCore();

  const handleClick = () => {
    spd.pdfPrinter
      .loadAndPrintJudgment(props.judgmentId)
      .catch(async response => {
        const error = await responseErrors(response as ResponseError);

        toast.error(`Wystąpił problem z wydrukiem orzeczenia. ${error}`);
      });
  };

  const handleClickEng = () => {
    spd.pdfPrinter
      .loadAndPrintJudgmentInEnglish(props.judgmentId)
      .catch(async response => {
        const error = await responseErrors(response as ResponseError);
        toast.error(
          `Wystąpił problem z wydrukiem orzeczenia w języku angielskim. ${error}`,
        );
      });
  };

  return (
    <>
      <ToastContainer />
      <OverlayTrigger
        overlay={
          <Tooltip style={{ position: 'fixed' }}>Wydruk orzeczenia</Tooltip>
        }
      >
        <Button
          onClick={e => {
            e.stopPropagation();
            handleClick();
          }}
          variant="btn-info"
        >
          <Icon.PrinterFill />
        </Button>
      </OverlayTrigger>
      {props.engPdfTemplateType && (
        <OverlayTrigger
          overlay={<Tooltip style={{ position: 'fixed' }}>Wersja ang.</Tooltip>}
        >
          <Button
            onClick={e => {
              e.stopPropagation();
              handleClickEng();
            }}
            variant="btn-info"
          >
            <Icon.PrinterFill />
          </Button>
        </OverlayTrigger>
      )}
    </>
  );
};
